<template>
	<div :class="`${relative ? 'border border-gray-200 dark:border-gray-800' : ''} px-2 py-1 rounded flex flex-col text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-900 cursor-pointer`">
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps<{
	relative?:boolean,
}>()
</script>
